import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentLocation } from 'shared/selectors/location';
import { getGeoSuggestLocation } from 'shared/utils/getGeoSuggestLocation';

export function useRegion() {
  const location = useSelector(selectCurrentLocation);
  const id = getGeoSuggestLocation(location);

  return useMemo(
    () => ({
      id,
      displayName: typeof location === 'object' ? location.displayName : undefined,
    }),
    [location, id],
  );
}
